import type { ProductSearchBar } from "@ui-d2c/types";

/** Loads the product suggestions of the storefront search for a query. */
export async function fetchSuggestionsFromApi(
  baseUrl: string,
  query: string,
  signal?: AbortSignal
): Promise<ProductSearchBar[]> {
  let url: string;
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "localhost"
  ) {
    const path = new URL(baseUrl).pathname;
    url = `/api/search-autocomplete?${new URLSearchParams({ term: query, path })}`;
  } else {
    url = `${baseUrl}search/autocomplete/SearchBox?${new URLSearchParams({ term: query })}`;
  }
  const response = await fetch(url, { signal });
  if (!response.ok) {
    throw new Error(`${response.status}`);
  }
  const data = (await response.json()) as { mainProduct?: ProductSearchBar[] };
  return data.mainProduct ?? [];
}

/**
 * Links a suggestion into the market, e.g. `/de/de` and
 * `/product/scott-spark` become `/de/de/product/scott-spark`.
 */
export function getSuggestionHref(basePath: string, url: string): string {
  return `${basePath.replace(/\/+$/, "")}/${url.replace(/^\/+/, "")}`;
}

/** Storefront base URL of the current market, e.g. `https://…/ch/de/`. */
export function getBaseUrl() {
  try {
    // Check if 'window' is defined (browser environment)
    if (
      typeof window === "undefined" ||
      window.location.hostname === "localhost" ||
      window.location.hostname === "scott-sports-test.com"
    ) {
      return "https://www.scott-sports.com/ch/fr/";
    }
    const PATH_SEGMENTS_FOR_BASE = 3;
    const fullUrl = window.location.href;
    const url = new URL(fullUrl);
    const basePath = url.pathname
      .split("/")
      .slice(0, PATH_SEGMENTS_FOR_BASE)
      .join("/");
    return `${url.origin}${basePath}/`;
  } catch (_error: unknown) {
    return null;
  }
}
